import api from "../services/api";

import { IImagem } from "../interfaces";

export interface IRegionalManagerListModel {
    id?: string;
    status: number;
    cpf: string;
    nome: string;
    cidade: string;
}

class ImagemRepository {

    public GetByReferenceId = async (id: string): Promise<IImagem[]> => {
        const response = await api.get<IImagem[]>(`imagem/${id}`);

        return response.data;
    }

    public DeleteById = async (id: string): Promise<void> => {
        await api.delete(`imagem/${id}`);
    }
}

const imagemRepository = new ImagemRepository();
export default imagemRepository;
